import {Component, Input, OnInit} from '@angular/core';
import {
    BaseModalComponent,
    EpsonPrinterService,
    LoadingService,
    Organization,
    PrinterService,
    StarPrinterService,
    WifiPrinter,
    WifiPrinterService
} from 'brewbill-lib';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AlertController, ModalController} from '@ionic/angular';

@Component({
    selector: 'bb-connect-printer',
    templateUrl: './connect-printer.component.html',
    styleUrls: ['./connect-printer.component.scss'],
})
export class ConnectPrinterComponent extends BaseModalComponent implements OnInit {
    @Input() organization: Organization;
    @Input() printer: WifiPrinter;
    connected = false;
    loaded = false;
    type: string;

    formGroup: FormGroup;

    constructor(
        modalController: ModalController,
        private epsonPrinterService: EpsonPrinterService,
        private starPrinterService: StarPrinterService,
        private printerService: PrinterService,
        private wifiPrinterService: WifiPrinterService,
        private alertController: AlertController,
        private loadingService: LoadingService,
        private formBuilder: FormBuilder
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.formGroup = this.formBuilder.group({
            parentId: this.organization.id,
            id: !!this.printer ? this.printer.id : null,
            name: [!!this.printer ? this.printer.name : null, Validators.required],
            type: [!!this.printer ? this.printer.type : 'EPSON', Validators.required],
            emulation: [!!this.printer ? this.printer.emulation : 'StarPRNT'],
            ipAddress: [!!this.printer ? this.printer.ipAddress : null, Validators.required],
            columns: [!!this.printer ? this.printer.columns : 35, [Validators.required, Validators.min(0)]]
        });

        this.subscribe(this.printerService.connected.subscribe(c => {
            if (this.loaded && !this.connected && !!c) {
                this.close();
            }
            this.connected = !!c;
            this.type = this.printerService.type;

            this.loaded = true;
        }));
    }

    connect() {
        const wifiPrinter = new WifiPrinter(this.formGroup.value);
        this.loadingService.present('Testing connection.');
        if (wifiPrinter.type === 'EPSON') {
            this.epsonPrinterService.connect(wifiPrinter, 0, true, true)
                .then(async (connected: boolean) => {
                    await this.handleConnection(wifiPrinter, connected);
                });
        } else {
            this.starPrinterService.connect(wifiPrinter, true)
                .then(async (connected: boolean) => {
                    await this.handleConnection(wifiPrinter, connected);
                });
        }
    }

    async handleConnection(wifiPrinter: WifiPrinter, connected: boolean) {
        this.loadingService.dismiss();
        if (connected) {
            this.save(wifiPrinter);
        } else {
            const alert = await this.alertController.create({
                cssClass: 'brewbill-alert',
                header: 'Failed Connection',
                message: `The connection to ${wifiPrinter.ipAddress} failed. Would you like to save anyway?`,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary'
                    }, {
                        text: 'Yes',
                        handler: async () => {
                            this.save(wifiPrinter);
                        }
                    }
                ]
            });

            await alert.present();
        }
    }

    save(wifiPrinter: WifiPrinter) {
        this.loadingService.present();
        if (!!wifiPrinter.id) {
            this.wifiPrinterService.update(wifiPrinter).subscribe(w => {
                this.loadingService.dismiss();
                this.close(new WifiPrinter(w));
            });
        } else {
            this.wifiPrinterService.create(wifiPrinter).subscribe(w => {
                this.loadingService.dismiss();
                this.close(new WifiPrinter(w));
            });
        }
    }
}
